@if(volunteerDetails(); as volunteer) {
<div class="volunteer-application-overview-content-dialog-part d-flex flex-column h-100">
	<h3>
		{{volunteer.person.fullName}}
		<span class="ms-2 pointer" type="button" title="View Person" (click)="openPersonDialog(volunteer.person.id)">
			<i class="fa-regular fa-user"></i>
		</span>
	</h3>
	<div class="flex-grow-1">
		@if(currentView() == 'lead') {
		<lead-volunteer-application-overview-content-dialog-part class="h-100"></lead-volunteer-application-overview-content-dialog-part>
		} @else {
		<volunteer-overview-content-dialog-part class="h-100"></volunteer-overview-content-dialog-part>
		}
	</div>
</div>
}